export const GET_USAGE = `
    query GetUsage($company_id: ID!, $feature:String!) {
        usage(company_id: $company_id, feature:$feature)
    }
`
